"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyRouteParamsSchema = exports.UpdateCompanyDtoSchema = exports.CreateCompanyDtoSchema = exports.CompanyAdminResponseSchema = exports.CompanyAdminSchema = exports.CompaniesResponseSchema = exports.CompanyListItemSchema = exports.GasStationCardNetworksResponseSchema = exports.GasStationCardNetworkSchema = void 0;
const zod_1 = require("zod");
const licenseItem_1 = require("./licenseItem");
const rest_area_1 = require("./rest-area");
const CompanyNameSchema = zod_1.z.string().trim().min(1).max(200);
const MaxBookingsPerMonthSchema = zod_1.z.number().int().min(0);
const MaxParkingPriceEurSchema = zod_1.z.number().min(0).max(rest_area_1.ABSOLUTE_MAX_PARKING_PRICE_EUR).nullable();
const LicenseItemsSchema = zod_1.z.array(zod_1.z.nativeEnum(licenseItem_1.LicenseItem));
const GasStationCardNetworkIdsSchema = zod_1.z.array(zod_1.z.string().uuid());
exports.GasStationCardNetworkSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
});
exports.GasStationCardNetworksResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.GasStationCardNetworkSchema),
});
exports.CompanyListItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    maxBookingsPerMonth: zod_1.z.number().int(),
    maxParkingPriceEur: zod_1.z.number().nullable(),
    licenseItems: LicenseItemsSchema,
    userCount: zod_1.z.number().int(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.CompaniesResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.CompanyListItemSchema),
});
exports.CompanyAdminSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    normalizedName: zod_1.z.string(),
    maxBookingsPerMonth: zod_1.z.number().int(),
    maxParkingPriceEur: zod_1.z.number().nullable(),
    licenseItems: LicenseItemsSchema,
    gasStationCardNetworks: zod_1.z.array(exports.GasStationCardNetworkSchema),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.CompanyAdminResponseSchema = zod_1.z.object({
    data: exports.CompanyAdminSchema,
});
exports.CreateCompanyDtoSchema = zod_1.z
    .object({
    name: CompanyNameSchema,
    maxBookingsPerMonth: MaxBookingsPerMonthSchema.optional(),
    maxParkingPriceEur: MaxParkingPriceEurSchema.optional(),
    licenseItems: LicenseItemsSchema.optional(),
    gasStationCardNetworkIds: GasStationCardNetworkIdsSchema.optional(),
})
    .strict();
exports.UpdateCompanyDtoSchema = zod_1.z
    .object({
    name: CompanyNameSchema,
    maxBookingsPerMonth: MaxBookingsPerMonthSchema,
    maxParkingPriceEur: MaxParkingPriceEurSchema,
    licenseItems: LicenseItemsSchema,
    gasStationCardNetworkIds: GasStationCardNetworkIdsSchema,
})
    .partial()
    .strict();
exports.CompanyRouteParamsSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
//# sourceMappingURL=company-admin.js.map